export default [
  {
    path: "/092101540d2e6a1bf64d9257",
    name: "invoice-create",
    meta: {
      title: "Create Invoice",
      authRequired: true,
      acc: ["y65820"],
    },
    component: () => import("../views/invoice/new-invoice.vue"),
  },
  {
    path: "/08f338747021e0ea9f7decd2",
    name: "invoice-list",
    meta: {
      title: "Invoices",
      authRequired: true,
      acc: ["y55721"],
    },
    component: () => import("../views/invoice/invoice-list.vue"),
  },
  {
    path: "/mes-invoice/:id?",
    name: "mes-invoice",
    meta: {
      title: "M.E.S Invoice ",
      authRequired: true,
    },
    component: () => import("@/views/invoice/mes-invoice.vue"),
  },
  {
    path: "/098c24b5378f2860f5ccd9ea/:id?",
    name: "invoice",
    meta: {
      title: "Invoice",
      authRequired: true,
      acc: ["y39367"],
    },
    component: () => import("../views/invoice/invoice.vue"),
  },
  {
    path: "/bc9be2e1e6d434077ead1e32/:id?",
    name: "transaction-invoice",
    meta: {
      title: "Transaction Invoice",
      authRequired: true,
      acc: ["y39367"],
    },
    component: () => import("../views/invoice/transaction-invoice.vue"),
  },
];
